import React from 'react'
import PropTypes from 'prop-types'

function EmailOutboxBatchActions({
  draftCount,
  failedCount,
  sending,
  canceling,
  retrying,
  onSendAll,
  onCancelAll,
  onRetryFailed,
}) {
  return (
    <div className="batch-actions mb-3 d-flex gap-2">
      <button
        onClick={onSendAll}
        disabled={draftCount === 0 || sending}
        className="btn btn-success"
        aria-label={`Send all ${draftCount} draft emails`}
      >
        {sending ? 'Sending...' : `📧 Send All Drafts (${draftCount})`}
      </button>

      <button
        onClick={onCancelAll}
        disabled={draftCount === 0 || canceling}
        className="btn btn-warning"
        aria-label={`Delete all ${draftCount} draft emails`}
      >
        {canceling ? 'Deleting...' : '🗑️ Delete All Drafts'}
      </button>

      <button
        onClick={onRetryFailed}
        disabled={failedCount === 0 || retrying}
        className="btn btn-secondary"
        aria-label={`Retry all ${failedCount} failed emails`}
      >
        {retrying ? 'Retrying...' : `🔁 Retry Failed (${failedCount})`}
      </button>
    </div>
  )
}

EmailOutboxBatchActions.propTypes = {
  draftCount: PropTypes.number.isRequired,
  failedCount: PropTypes.number.isRequired,
  sending: PropTypes.bool.isRequired,
  canceling: PropTypes.bool.isRequired,
  retrying: PropTypes.bool.isRequired,
  onSendAll: PropTypes.func.isRequired,
  onCancelAll: PropTypes.func.isRequired,
  onRetryFailed: PropTypes.func.isRequired,
}

export default EmailOutboxBatchActions
